import { getMonitoring } from "@/infrastructure/di/services";

export function useMonitoring(): ReturnType<typeof getMonitoring> {
  return getMonitoring();
}
